import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DndDropEvent } from 'ngx-drag-drop';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips.service';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { AttractImageVO, LFAttractScreensVO, AttractScreenVO, AttractScreenImageVO, AttractImage, SaveAttractScreenVO, AttractSet, ApplyAttractScreen } from '../../services/attract-screen.model';
import { AttractScreenService } from '../../services/attract-screen.service';
import { PageTitleService } from '../../services/page-title.service';

@Component({
  selector: 'app-attract-screen',
  templateUrl: './attract-screen.component.html',
  styleUrls: ['./attract-screen.component.scss', 
  '.moveIcon { background: url("'+`${environment.haloWebCloudBasePath}`+'/git/Icons/ico_move.svg") no-repeat; }']
})
export class AttractScreenComponent implements OnInit, OnDestroy {
  private showHaloMediaSponsoredContent: boolean = false;
  private attractScreenData: LFAttractScreensVO;
  private attractScreenMsg: string;
  private hasEditPermission: boolean = false;
  private showDeleteMsg = false;
  private selectedAttractScreen: AttractScreenVO | undefined;  
  private previewAttractScreen: AttractScreenVO | undefined;
  private selectedImageIndex: number;
  private resolutionWidth: number;  
  private resolutionHeight: number;
  private forEditImage: AttractScreenImageVO | undefined;
  private attractScreenEqListWrap: any;
  private originalAttractSets: AttractScreenVO[];
  private newAttractScreen: AttractScreenVO;
  private selectionInfo: SelectionInfo;
  private currentFacilityId: string;

  deleteModalProps = {
    title: this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [this.commonUtil.translateText('ATTRACT.SCREEN')]),
    message: 'DELETE.MODAL.MESSAGE',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
    hideSecondaryButton: false,
  };

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
  @ViewChild('bodyTemplate') bodyTemplate: TemplateRef<any>;
  @ViewChild('imageViewerTemplate') imageViewerTemplate: TemplateRef<any>;
  @ViewChild('imageEditorTemplate') imageEditorTemplate: TemplateRef<any>;
  @ViewChild('editorActionTemplate') editorActionTemplate: TemplateRef<any>;
  @ViewChild('consolePreviewTemplate') consolePreviewTemplate: TemplateRef<any>;
  @ViewChild('chooseEquipmentTemplate') chooseEquipmentTemplate: TemplateRef<any>;
  @ViewChild('chooseEquipmentActionTemplate') chooseEquipmentActionTemplate: TemplateRef<any>;
  
  constructor(
    private router: Router,
    private modal: HaloModalService,
    private pageTitleService: PageTitleService,
    private commonUtil: CommonUtil,
    private loader: HaloLoaderService,
    private attractScreenServ: AttractScreenService,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private _tips: HaloTipsService,
    private toast: HaloToastService) { }

  ngOnInit(): void {
    this.pageTitleService.setTitle('');
  }

  ngOnDestroy(): void {
    this._tips.onDismissed(true);
  }

  showHaloTips() {
    if(this.attractScreenData.has307Software && this.selectionInfo?.rootScopeData?.showAttractScreenPopup){
      this._tips.add([
        {flag: 'showAttractScreenPopup', key: 'attract307-publish', message: this.commonUtil.translateText('ATTRACT.3.07.MESSAGE'), pointerPosition: 'bottom' },
      ]);
    }
  }

  addNew() {
    if(this.attractScreenData?.attractSets[0].setId === '-1') return;
    var datePipe = new DatePipe('en-US');
    const specificConsole = this.selectionInfo.consoleType === 'bluth' || this.selectionInfo.consoleType === 'mulder';
    this.newAttractScreen = {
      setId: '-1',
      consoleType: this.selectionInfo.consoleType,
      images: specificConsole ? [{}] : [{}, {}, {}, {}, {}],
      userId: this.selectionInfo.rootScopeData?.currentUser?.userId?.toString(),
      name: `${this.commonUtil.translateText('DRAFT.CONFIRMATION.ATTRACTSCREEN')} ${datePipe.transform(Date.now(), 'MMddyyyy_H:mm')}`
    };
    if(this.selectionInfo.consoleType === 'discover') {
      this.newAttractScreen.message = '';
      this.newAttractScreen.messageFontColor = '#000000';
      this.newAttractScreen.backgroundColor = '#ffffff';
    }
    this.selectedAttractScreen = JSON.parse(JSON.stringify(this.newAttractScreen));
    if(this.selectedAttractScreen) this.attractScreenData.attractSets.unshift(this.selectedAttractScreen);

    // show newly added item
    this.showSelectedAttractScreen();
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  showCustomizedSponsorContent() {
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.commonUtil.translateText('CUSTOMIZE.SPONSORED.CONTENT.HEADER'),
      message: this.commonUtil.translateText('CUSTOMIZE.SPONSORED.CONTENT.MESSAGE'),
      bodyTemplate: this.bodyTemplate,
      footerTemplate: this.actionTemplate
    });
  }

  cancel() {
    let aIndex = 0;
    if(this.selectedAttractScreen?.setId === '-1') {
      this.selectedAttractScreen = JSON.parse(JSON.stringify(this.newAttractScreen));
    } else {
      aIndex = this.attractScreenData.attractSets.findIndex(a => a.setId === this.selectedAttractScreen?.setId);
      let tempAt = this.originalAttractSets.find(a => a.setId === this.selectedAttractScreen?.setId);
      this.selectedAttractScreen = this.selectedAttractScreen = JSON.parse(JSON.stringify(tempAt));
    }
    if(this.selectedAttractScreen) this.attractScreenData.attractSets[aIndex] = this.selectedAttractScreen;
    this.showSelectedAttractScreen();
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = this.attractScreenData.attractSets.some(a => a.isEdited);
  }

  showSelectedAttractScreen() {
    setTimeout(() => {
      //@ts-ignore
      $(`#collapse${this.selectedAttractScreen.setId}`).collapse('show');
    }, 100);
  }

  onCancel() {
    this.modal.close();
  }

  customize() {

  }

  onToggleCollapse(event: any, attractScreen: AttractScreenVO) {
    this.selectedAttractScreen = attractScreen;
    var expanded = event.target.getAttribute('aria-expanded');
    if(expanded === 'true'){
      this.selectedAttractScreen = undefined;
    }
  }

  private async getData(showTip: boolean) {
    const specificConsole = this.selectionInfo.consoleType === 'bluth' || this.selectionInfo.consoleType === 'mulder';
    try {
      this.loader.startProcess();
      this.attractScreenData = await this.attractScreenServ.getAttractScreens(this.currentFacilityId, this.selectionInfo.consoleType);
      if(this.attractScreenData && this.attractScreenData.attractSets) {
        if (specificConsole) {
          this.attractScreenData.attractSets.forEach(a => a.images = [a.images[0]]);
        }
        this.originalAttractSets = JSON.parse(JSON.stringify(this.attractScreenData.attractSets)); // clone original sets
      }
      this.selectedAttractScreen = undefined;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
      if(showTip) this.showHaloTips();
    } catch (error) {
      console.error("API error.")
    }
    finally {
      this.loader.endProcess();
      this.commonUtil.scrollTop();
    }
    let consoleTypeRights = this.commonUtil.rootScopeData?.consoleRights?.get(this.selectionInfo.consoleType);
    if(consoleTypeRights) {
      this.attractScreenMsg = specificConsole ? this.commonUtil.replaceValueAsHTMLOnTranslatedText('HALO.MEDIA.ATTRACT.SCREEN.MSG.ST',
      [consoleTypeRights.resolutionWidth, consoleTypeRights.resolutionHeight]) :
      this.commonUtil.replaceValueAsHTMLOnTranslatedText('HALO.MEDIA.ATTRACT.SCREEN.MSG',
      ['5', consoleTypeRights.resolutionWidth, consoleTypeRights.resolutionHeight]);
      this.resolutionHeight = consoleTypeRights.resolutionHeight;
      this.resolutionWidth = consoleTypeRights.resolutionWidth;
    } 
  }

  async confirmDelete() {
    this.showDeleteMsg = false;
    if(!this.selectedAttractScreen) return;
    if(this.selectedAttractScreen.setId !== '-1'){
      try {
        this.loader.startProcess();
        await this.attractScreenServ.deleteAttractScreen(this.selectedAttractScreen.setId, this.selectedAttractScreen.consoleType);
        await this.getData(false);
      } catch (error) {  
        console.error('API error.');
      }
      finally {
        this.loader.endProcess();
      }
    } else {
      this.attractScreenData.attractSets.splice(0, 1);
      this.selectedAttractScreen = undefined;
    }    
    this.commonUtil.scrollTop();
  }

  onDrop(event: DndDropEvent, index: number, list: AttractImageVO[]) {
    if( list && (event.dropEffect === "move") ) {
      if(this.selectedAttractScreen) {
        this.selectedAttractScreen.imageReordered = true;
        this.selectedAttractScreen.isEdited = true;
      } 
      let srcIdx = list.findIndex(i => i.name === event.data.name);
      let destItem = list[index];
      list[srcIdx] = destItem;
      list[index] = event.data;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }

  selectImage(idx: number) {
    this.selectedImageIndex = idx;
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.commonUtil.translateText('IMAGE.MANAGER'),
      bodyTemplate: this.imageViewerTemplate
    });
  }

  editImage(e: Event, image: AttractImageVO, idx: number) {
    e.stopPropagation();
    if(!image.name) return;
    this.loader.startProcess();
    this.selectedImageIndex = idx;
    this.attractScreenServ.getImageInfo(image.name)
      .then((res: AttractImage) => {
        let rgbColor = res.rgb?.split(',');
        if(!rgbColor || rgbColor.length < 2) rgbColor = ['0','0','0'];
        this.forEditImage = {
          id: '0',
          name: res.originalFileName,
          s3ObjectKey: res.sourceImageKey,
          sourceImageUrl: res.sourceImageUrl,
          contentType: `image/${res.fileType}`,
          orignalFileName: res.originalFileName,
          croppingParam: {uiX: res.croppingX, uiY: res.croppingY, uiH: res.croppingH, uiW: res.croppingW},
          enableBackgroundColor: !image.backgroundColor,
          redRGB: Number(rgbColor[0]),
          greenRGB: Number(rgbColor[1]),
          blueRGB: Number(rgbColor[2]),
          imageType: 'D',
          consoleType: res.consoleType
        };
        if(this.selectedAttractScreen) this.selectedAttractScreen.isEdited = true;
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
        this.showEditImage();
      })
    .catch(() => {
      console.error('API error.')
    })
    .finally(() => {
      this.loader.endProcess();
    });    
  }

  deleteImage(e: Event, idx: number) {
    e.stopPropagation();
    if(this.selectedAttractScreen && this.selectedAttractScreen.images && idx >= 0) {
      this.selectedAttractScreen.isEdited = true;
      this.selectedAttractScreen.hasImage = this.selectedAttractScreen.images?.some(i => !!i.name);
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
      let selectedImage = this.selectedAttractScreen.images[idx];
      if(selectedImage) {
        selectedImage.backgroundColor = undefined;
        selectedImage.name = undefined;
        selectedImage.url = undefined;
      }   
    }
  }

  onImageAdded(image: AttractScreenImageVO) {
    this.forEditImage = image;
    this.showEditImage();
  }

  onImageSelected(image: AttractImage) {
    this.modal.close();
    if(this.selectedAttractScreen && this.selectedAttractScreen.images && this.selectedImageIndex >= 0) {
      this.selectedAttractScreen.isEdited = true;
      this.selectedAttractScreen.hasImage = true;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
      let selectedImage = this.selectedAttractScreen.images[this.selectedImageIndex];
      if(selectedImage) {
        selectedImage.name = image.id;
        selectedImage.backgroundColor = image.rgb;
        selectedImage.url = image.thumbnailUrl;
        selectedImage.width = image.sourceImageWidth;
      }      
    }
  }

  async uploadImage() {
    if(this.forEditImage) {
      this.loader.startProcess();
      try {
        // for newly added image
        if(!this.forEditImage.s3ObjectKey) {
          let response: AttractImage = await this.attractScreenServ.uploadImage(this.forEditImage.formData);
          this.forEditImage.s3ObjectKey = response?.sourceImageKey;
          this.forEditImage.sourceImageUrl = response?.sourceImageUrl;
          this.forEditImage.imageFile = undefined;
          this.forEditImage.formData = undefined;
        }
        let attractImage: AttractImage = await this.attractScreenServ.saveImage(this.forEditImage);
        if(this.forEditImage.imageType === 'D' && this.selectedAttractScreen) {
          // for edit, update the selected image
          let selectedImage = this.selectedAttractScreen.images[this.selectedImageIndex];
          if(selectedImage) {
            selectedImage.name = attractImage.id;
            selectedImage.backgroundColor = attractImage.rgb;
            selectedImage.url = attractImage.thumbnailUrl;
            selectedImage.width = attractImage.sourceImageWidth;
          }
        }
      } catch (error) {
        console.error('API error.')
      } 
      this.loader.endProcess();
      this.forEditImage = undefined;
      this.modal.close();
    }
  }

  showEditImage() {
    this.modal.addForeground({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.XLarge,
      title: this.commonUtil.translateText('UPLOAD.IMAGE'),
      bodyTemplate: this.imageEditorTemplate,
      footerTemplate: this.editorActionTemplate
    });
  }

  onImageUpdated(image: AttractScreenImageVO) {
    this.forEditImage = image;
  }

  async save() {
    let editAttractSet = this.generateAttractSet();
    if(!this.selectedAttractScreen || !editAttractSet) return;
    let saveAttractScreen: SaveAttractScreenVO = {
      attractSet: editAttractSet,
      facilityIds: [this.currentFacilityId],   // consider multisite 
      isReordered: this.selectedAttractScreen.imageReordered==true
    }
    this.loader.startProcess();
    try {
      let res: any = await this.attractScreenServ.saveEditAttractScreen(saveAttractScreen);
      this.selectedAttractScreen.setId = res.setId;
      this.selectedAttractScreen.updatedAt = res.updatedAt;
      this.selectedAttractScreen.imageReordered = false;
      this.selectedAttractScreen.isEdited = false;
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = this.attractScreenData.attractSets.some(a => a.isEdited);;
      this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.SAVED.SUCCESSFULLY', ['<b>'+this.selectedAttractScreen.name+'</b>']), EToastType.SUCCESS);
    } catch (error) {
      console.error('API error.')
    }
    this.loader.endProcess();
  }

  showPreviewScreen(attractScreen: AttractScreenVO) {
    if(!attractScreen.hasImage || !attractScreen.name) return;
    this.previewAttractScreen = attractScreen;
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.commonUtil.translateText('VIEW.ON.CONSOLE'),
      bodyTemplate: this.consolePreviewTemplate
    });
  }

  async chooseEquipment() {
    let activityIds = this.selectionInfo.consoleObj?.equipments?.filter(e => e.activityId !== '-1').map(e => e.activityId) ?? [];
    this.loader.startProcess();
    try {
      this.attractScreenEqListWrap = await this.attractScreenServ.getAttractScreenEquipmentList({
        facilityIds: [this.currentFacilityId], // consider multisite (use multi facility in facility service)
        consoleType: this.selectionInfo.consoleType,
        activityIds: activityIds
      });
      this.modal.add({
        dismissible: true,
        titleUppercase: true,      
        modalSize: HaloModalSize.Large,
        title: this.hasEditPermission?this.commonUtil.translateText('CHOOSE.EQUIPMENT'):this.commonUtil.translateText('VIEW.EQUIPMENT'),
        bodyTemplate: this.chooseEquipmentTemplate,
        footerTemplate: this.chooseEquipmentActionTemplate
      });
    } catch (error) {
      console.error('API error.')
    }    
    this.loader.endProcess();
  }

  async publish() {
    this.modal.close();
    let applyAttractSet = this.generateAttractSet();
    if(!this.selectedAttractScreen || !applyAttractSet) return;
    let selectedAsset: string[] = [];
    this.attractScreenEqListWrap.attractScreenEquipList.forEach((g: any) =>{
      g.attractScreenAssetsList.forEach((e: any) => {
        if(e.checked) selectedAsset.push(e.assetId);
      });
    });
    if(selectedAsset.length < 1) return;
    
    let data: ApplyAttractScreen = {
      attractScreen: applyAttractSet,
      facilityIds: [this.currentFacilityId],
      isReordered: this.selectedAttractScreen.imageReordered == true,
      isApply: true,
      assetIds: selectedAsset
    };
    this.loader.startProcess();
    try {
      let res: any = await this.attractScreenServ.applyAttractScreen(data);
      let imageCount = 1;
      if(!(this.selectionInfo.facility.summary.staffPermissionData.haloMediaOptedIn === 'false' && this.selectionInfo.consoleType === 'bluth')) {
        imageCount = this.selectedAttractScreen.images.filter(i => !!i.name).length;
      }
      // this.amplitudeAnalytics.logEvent('Attract Screen - Choose Equipment - Publish', {
      //   'Published_Images_count': imageCount,
      //   'Console_Type': this.selectionInfo.consoleType
      // });

      if(res && res.assetList?.length > 0) {
        this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('ERROR.UNABLE.TO.UPLOAD.ATTRACTSCREEN.TO.CONSOLES', [`<b>${res.assetList.length}</b>`]), EToastType.ERROR);
      } else {        
        this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.PUBLISHED.SUCCESSFULLY', [`<b>${this.selectedAttractScreen.name}</b>`]), EToastType.SUCCESS);        
        this.getData(false);
      }
    } catch (error) {
      console.error('API error.')
    }
    this.loader.endProcess();
  }

  generateAttractSet(): AttractSet | undefined {
    if(!this.selectedAttractScreen) return undefined;
    let attractSet = new AttractSet();
    attractSet.name = this.selectedAttractScreen.name ?? '';
    attractSet.consoleType = this.selectedAttractScreen.consoleType ?? '';
    if(this.selectedAttractScreen.setId !== '-1') attractSet.id = this.selectedAttractScreen.setId;

    if(this.selectedAttractScreen.consoleType === 'discover') {
      attractSet.message = encodeURIComponent(this.selectedAttractScreen.message ?? '');
      attractSet.backgroundColor = this.selectedAttractScreen.backgroundColor ?? '';
      attractSet.messageColor = this.selectedAttractScreen.messageFontColor ?? '';
      attractSet.hasScrolling = attractSet.message.length > 0;
    }
    if(this.selectedAttractScreen.images[0].name) attractSet.firstImage = { id: this.selectedAttractScreen.images[0].name };
    const specificConsole = this.selectionInfo.consoleType === 'bluth' || this.selectionInfo.consoleType === 'mulder';
    //for non halo media bluth
    if(!specificConsole && !(this.selectionInfo.facility.summary.staffPermissionData.haloMediaOptedIn === 'false' && this.selectionInfo.consoleType === 'bluth')) {
      if(this.selectedAttractScreen.images[1].name) attractSet.secondImage = { id: this.selectedAttractScreen.images[1].name };
      if(this.selectedAttractScreen.images[2].name) attractSet.thirdImage = { id: this.selectedAttractScreen.images[2].name };
      //todo: confirm if 4th and 5th images need to be included for bluth 
      if(this.selectedAttractScreen.images[3].name) attractSet.fourthImage = { id: this.selectedAttractScreen.images[3].name };
      if(this.selectedAttractScreen.images[4].name) attractSet.fifthImage = { id: this.selectedAttractScreen.images[4].name };
    }
    return attractSet;
  }

  private onEdit(attractScreen: AttractScreenVO) {
    attractScreen.isEdited = true;
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }
  
  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.showHaloMediaSponsoredContent = selectionInfo.facility.summary.staffPermissionData.haloMediaOptedIn === 'true';
      this.selectedAttractScreen = undefined;
      this.hasEditPermission = selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' ||
      selectionInfo.facility.summary?.userRights.customize === 'F';
      if(selectionInfo.facility.summary?.facilityRights.attractScreen === 'true' &&
        (this.hasEditPermission || selectionInfo.facility.summary?.userRights.customize !== 'H')) {    
        let isFacilityChanged = this.currentFacilityId != selectionInfo.facility.facilityId;
        this.currentFacilityId = selectionInfo.facility.facilityId;
        this.getData(isFacilityChanged);
      } else if(this.selectionInfo.facility.summary.facilityRights.productSetting === 'true'){
        this.router.navigate(['/equipmentSettings/setting']);
      } else{
        this.commonUtil.redirectToAvailablePage();
      } 
    });
  }
}
